/**
 * Creates a viewport meta tag if one does not exist
 *
 * @returns {void}
 */
export default function createViewportMeta() {
  // eslint-disable-next-line quotes
  if (document.querySelector('meta[name="viewport"]')) {
    return;
  }

  const meta = document.createElement("meta");
  meta.content = "width=device-width, user-scalable=0, initial-scale=1.0";
  meta.id = `convo-meta-${Date.now()}`;
  meta.name = "viewport";
  document.head.appendChild(meta);
  return;
}
